import React, { Component, createRef } from "react";
import { NavLink } from "react-router-dom";
// Assets
import { FiEye } from "react-icons/fi";
import layoutOne from "../../../images/layout1.png";
import layoutTwo from "../../../images/layout2.png";
import layoutThree from "../../../images/layout3.png";
import microSettingIc from "../../../images/microSettingIc.png";
import eyeIc from "../../../images/icon/eye-ic.png";
import {
  AiOutlineCloudUpload,
  AiFillCloseCircle,
  AiOutlineMinusCircle,
  AiFillPlusCircle,
} from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { HiOutlineTrash } from "react-icons/hi";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { BsArrowRight } from "react-icons/bs";
import { RiFacebookFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import loco from "../../../images/games/loco.png";
// Utils
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import {
  capitalize,
  errorHandler,
  loadCountryCodes,
  updateLoader,
} from "../../../utils/common.utils";
import ColorPicker from "../../../components/common/ColorPicker";
// Services
import { AxiosResponse, AxiosError } from "axios";
import CommonApis from "../../../helper/common.api";
import MicroWebSiteApis from "../../../helper/microwebsite.api";
import OrganizationApis from "../../../helper/organization.api";
// Modals
import { Modal } from "react-bootstrap";
import OrgAddMoreDetails from "../../popup/OrgAddMoreDetails";
import ConfirmationModal from "../../popup/ConfirmationModal";
import Sponsor from "../../popup/Sponsor";
// Layouts
import LayoutOne from "../layouts/LayoutOne";
import LayoutTwo from "../layouts/LayoutTwo";
import LayoutThree from "../layouts/LayoutThree";
import { HEADING, SOCIAL_MEDIA_PLATFORM } from "../../../utils/Strings.utils";
import ImageCropper from "../../common/ImageCropper/ImageCropper";

const DELAY = 1500;

export default class MicroWebsiteConfiguration extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgCustomImage: null,
      customImages: [null, null, null, null, null, null],
      selectLayout: 0,
      logoImage: null,
      bannerImage: null,
      microWebSiteLogo: null,
      microWebSiteBannerImage: null,
      aboutUsImage: null,
      sponsorImage: null,
      selectedLayout: "one",
      openSponsor: false,
      reqErrorMsg: "",
      openAddMoreDetails: false,
      appendDetails: false,
      extraDetails: this.extraDetails,
      microWebSiteData: {},
      create: true,
      invalidImage: null,
      isTime: false,
      sponsorForUpdate: null,
      sponsorIndex: null,
      openConfirm: false,
      deleteSponsorId: null,
      confirm: {},
      openPreview: false,
      previewData: {},
      color: {
        background: "#620ff0",
        primary: "#cfb5fa",
        secondary: "#9a65f6",
      },
      organizationData: {},
      aboutUsText: "",
      countryCodes: [],
      // Cropper state
      showLogoCropper: false,
      showBannerCropper: false,
      logoCropperImageUrl: "",
      bannerCropperImageUrl: "",
      logoCropperAspectRatio: 1, // 100x100 = 1:1 aspect ratio
      bannerCropperAspectRatio: 1189 / 200, // 1189x200 aspect ratio
    };

    // Services
    this.commonApi = new CommonApis();
    this.organizationApi = new OrganizationApis();
    this.microWebSiteService = new MicroWebSiteApis();
    // Initials
    this.formikRef = createRef();
    this.organizationId = null;
    this.sponsorForUpdate = {};
    this.formTempData = {};
    this.customImageIndex = 0;
    this.sponsorArray = [];
    //Social media array
    this.extraDetails = [
      {
        label: SOCIAL_MEDIA_PLATFORM.INSTAGRAM.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.INSTAGRAM.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.FACEBOOK.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.FACEBOOK.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.X.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.X.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.TELEGRAM.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.TELEGRAM.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.YOUTUBE.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.YOUTUBE.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.LOCO.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.LOCO.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
      {
        label: SOCIAL_MEDIA_PLATFORM.TWITCH.LABEL,
        key: SOCIAL_MEDIA_PLATFORM.TWITCH.KEY,
        value: "",
        isChecked: false,
        error: "",
      },
    ];
    // Fetch initial values
    this.getOrgData(props.match.params.id.replace("config-", ""));
  }

  componentDidMount() {
    // To enable navigation
    this.props.showOrHideNav(true);
    // To fetch country codes from common utils
    loadCountryCodes(this.setCountryCodes);
    // Reset initial values
    setTimeout(() => {
      this.setState({ load: true, isTime: true });
    }, DELAY);
    if (this.props.match.params.id.includes("config-")) {
      this.setState({ create: false });
      // First fetch microwebsite data, then organization data
      this.getData()
        .then(() => {
          // Only fetch org data after microwebsite data is loaded
          this.getOrgData(this.props.match.params.id.replace("config-", ""));
        })
        .catch(() => {
          // If microwebsite data fails, still fetch organization data as fallback
          this.getOrgData(this.props.match.params.id.replace("config-", ""));
        });
    }
  }

  // To fetch additional organization details
  getOrgData(id) {
    const data = {
      _id: id,
    };
    this.organizationApi
      .getOrganizations(data)
      .then(res => {
        let details = this.state.extraDetails;
        let orgMediaDetails = res.data.result[0].socialMediaDetails;

        details = [
          {
            label: SOCIAL_MEDIA_PLATFORM.INSTAGRAM.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.INSTAGRAM.KEY,
            value: orgMediaDetails.instagram ? orgMediaDetails.instagram : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.FACEBOOK.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.FACEBOOK.KEY,
            value: orgMediaDetails.facebook ? orgMediaDetails.facebook : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.X.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.X.KEY,
            value: orgMediaDetails.x ? orgMediaDetails.x : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.TELEGRAM.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.TELEGRAM.KEY,
            value: orgMediaDetails.telegram ? orgMediaDetails.telegram : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.YOUTUBE.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.YOUTUBE.KEY,
            value: orgMediaDetails.youtube ? orgMediaDetails.youtube : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.LOCO.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.LOCO.KEY,
            value: orgMediaDetails.loco ? orgMediaDetails.loco : "",
            isChecked: false,
            error: "",
          },
          {
            label: SOCIAL_MEDIA_PLATFORM.TWITCH.LABEL,
            key: SOCIAL_MEDIA_PLATFORM.TWITCH.KEY,
            value: orgMediaDetails.twitch ? orgMediaDetails.twitch : "",
            isChecked: false,
            error: "",
          },
        ];

        // Only set organization images if microwebsite doesn't have specific images
        const updateState = {
          logoImage: res.data.result[0].logo,
          bannerImage: res.data.result[0].coverImage,
          organizationData: res.data.result[0],
          extraDetails: details,
        };

        // Only use organization images as fallback if microwebsite images are not set
        if (!this.state.microWebSiteLogo) {
          updateState.microWebSiteLogo = res.data.result[0].logo;
        }
        if (!this.state.microWebSiteBannerImage) {
          updateState.microWebSiteBannerImage = res.data.result[0].coverImage;
        }

        this.setState(updateState);
      })
      .catch(err => {
        errorHandler(err, this.props.logout);
      });
  }

  // Sponsor delete confirmation msg
  sponsorDeleteMsg = name => {
    return (
      <p className="fs-14 fw-600 text-center text-white-50">
        Are you sure you want to delete {name} from sponsors?
      </p>
    );
  };

  // Fetch initial site values
  getData() {
    var requestBody = {
      organizationId: this.props.match.params.id.replace("config-", ""),
    };
    this.organizationId = this.props.match.params.id.replace("config-", "");
    this.props.updateLoader(true);

    return this.microWebSiteService
      .getSingleMicroWebsite(requestBody)
      .then(response => {
        const data = response.data.result[0];
        let customeImg = [];
        for (let i = 0; i < this.state?.customImages.length; i++) {
          if (data?.customImage[i]) {
            customeImg.push(data?.customImage[i]);
          } else {
            customeImg.push(null);
          }
        }
        for (let i = 0; i < this.extraDetails.length; i++) {
          if (data?.contactDetails[this.extraDetails[i].label]) {
            this.extraDetails[i].value = data?.contactDetails[this.extraDetails[i].label];
            this.extraDetails[i].isChecked = true;
          }
        }

        this.setState({
          microWebSiteData: data,
          selectedLayout: data?.layout ? data?.layout : this.state.selectedLayout,
          color: data?.color ? data?.color : this.state.color,
          microWebSiteLogo: data?.logo ? data.logo : null,
          microWebSiteBannerImage: data?.banner ? data.banner : null,
          aboutUsImage: data?.aboutUs?.img ? data.aboutUs.img : null,
          customImages: customeImg,
          extraDetails: this.extraDetails,
          aboutUsText: data?.aboutUs?.bio,
        });
        this.sponsorArray = data?.sponsors ? data.sponsors : [];
        this.props.updateLoader(false);
      })
      .catch(reason => {
        this.props.updateLoader(false);
        if (reason.response?.status === 404) {
          // this.props.updateLoader(false);
        } else {
          errorHandler(reason, this.props.logout);
        }
      });
  }

  // Temp formik value saved
  formValueChange = (e, key) => {
    this.formTempData[key] = e.target.value;
  };

  // Reset Custom images
  resetCustomImage = (e, i) => {
    e.preventDefault();
    e.stopPropagation();
    const customImagesArray = [...this.state.customImages];
    customImagesArray[i] = null;
    this.setState({ customImages: customImagesArray });
  };

  // Open upload media
  triggerInputFile = () => this.fileInput.click();
  triggerInputFile2 = () => this.fileInput2.click();
  triggerInputFile3 = (e, index) => {
    e.preventDefault();
    this.customImageIndex = index;
    this.fileInput3.click();
  };
  triggerInputFile4 = () => this.fileInput4.click();
  triggerInputFile5 = () => this.fileInput5.click();

  // Toggle Modals
  toggleModal = key => {
    this.setState({
      [key]: !this.state[key],
    });
  };

  // Upload image
  onImageChange = (event, type) => {
    event.preventDefault();

    this.setState({
      invalidImage: null,
    });

    //type : bannerImage, logoImage
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      if (!img.name.match(/\.(jpg|jpeg|png)$/)) {
        toast.warning("Please select a valid image type.");
        event.target.value = null;
        return false;
      }

      // Use cropper for logo and banner images
      if (type === "microWebSiteLogo") {
        this.setState({
          showLogoCropper: true,
          logoCropperImageUrl: URL.createObjectURL(img),
          logoCropperAspectRatio: 1,
        });
      } else if (type === "microWebSiteBannerImage") {
        this.setState({
          showBannerCropper: true,
          bannerCropperImageUrl: URL.createObjectURL(img),
          bannerCropperAspectRatio: 1189 / 200,
        });
      } else {
        // For other images, use the original upload logic
        this.setState({
          [type]: URL.createObjectURL(img), //loader image
        });

        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        this.props.updateLoader(true);
        this.commonApi
          .uploadSingleImg(formData)
          .then(response => {
            this.props.updateLoader(false);
            this.setState({
              [type]: response.data.result, //
              reqErrorMsg: null,
            });
          })
          .catch(err => {
            errorHandler(err, this.props.logout);
            this.setState({
              [type]: null,
            });
            this.props.updateLoader(false);
          }); //set null to image and display error message in toast
      }
      event.target.value = null;
    }
  };

  // Handle logo cropper completion
  handleLogoCropComplete = (croppedImageUrl, blob) => {
    this.setState({
      microWebSiteLogo: croppedImageUrl,
      showLogoCropper: false,
    });

    const formData = new FormData();
    formData.append("file", blob);
    this.props.updateLoader(true);
    this.commonApi
      .uploadSingleImg(formData)
      .then(response => {
        this.setState({
          microWebSiteLogo: response.data.result,
          reqErrorMsg: null,
        });
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.setState({
          microWebSiteLogo: null,
        });
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  // Handle banner cropper completion
  handleBannerCropComplete = (croppedImageUrl, blob) => {
    this.setState({
      microWebSiteBannerImage: croppedImageUrl,
      showBannerCropper: false,
    });

    const formData = new FormData();
    formData.append("file", blob);
    this.props.updateLoader(true);
    this.commonApi
      .uploadSingleImg(formData)
      .then(response => {
        this.setState({
          microWebSiteBannerImage: response.data.result,
          reqErrorMsg: null,
        });
        this.props.updateLoader(false);
      })
      .catch(err => {
        this.setState({
          microWebSiteBannerImage: null,
        });
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  // Hide logo cropper
  hideLogoCropper = () => {
    this.setState({
      showLogoCropper: false,
      logoCropperImageUrl: "",
      logoCropperAspectRatio: 1,
    });
  };

  // Hide banner cropper
  hideBannerCropper = () => {
    this.setState({
      showBannerCropper: false,
      bannerCropperImageUrl: "",
      bannerCropperAspectRatio: 1189 / 200,
    });
  };

  // Clear Images
  onClearImage = (event, type) => {
    event.preventDefault();
    this.setState({
      [type]: null,
    });
  };

  // Upload Custom Images
  onCustomImageChange = event => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      if (!img.name.match(/\.(jpg|jpeg|png)$/)) {
        toast.warning("Please select a valid image type.");
        return false;
      }
      var arr = this.state.customImages;
      arr[this.customImageIndex] = URL.createObjectURL(img);
      this.setState({
        customImages: arr,
        orgCustomImage: URL.createObjectURL(img),
      });
      const formData = new FormData();
      formData.append("file", event.target.files[0]);
      this.props.updateLoader(true);
      this.commonApi
        .uploadSingleImg(formData)
        .then(response => {
          this.props.updateLoader(false);
          var customImagesArray = this.state.customImages;
          customImagesArray[this.customImageIndex] = response.data.result;
          this.setState({
            customImages: customImagesArray,
          });
        })
        .catch(err => {
          console.log(err);
          this.props.updateLoader(false);
        });
    }
  };

  //For re-capcha
  handleChange = value => {
    this.setState({ recaptcha: value });
    // if value is null recaptcha expired
    if (value === null) this.setState({ expired: "true" });
  };

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!" });
  };

  // To select Colors
  selectColor = (e, type, index) => {
    e.preventDefault();
    const data = this.state.color;
    data[type] = index;
    this.setState({
      color: data,
    });
  };

  // Toggle Previous
  changeActivePreview = e => {
    this.setState({ selectedLayout: e.target.id });
  };

  // To close sponsor modal
  closeSponsor = () => {
    this.setState({
      sponsorForUpdate: null,
      openSponsor: false,
      sponsorImage: null,
    });
  };

  // To Open confirmation popup
  onClickOpenConfirm = (key, msg) => {
    const data = {
      msg: msg ? msg : "",
      key: key ? key : "",
    };
    this.setState({
      openConfirm: !this.state.openConfirm,
      confirm: data,
    });
  };

  // Add Sponsor
  addSponsor = (values, logo) => {
    this.setState({
      invalidImage: null,
    });

    const data = {
      name: values.name,
      type: values.type,
      logo: logo,
      isDeleted: false,
    };
    this.sponsorArray.push(data);
    this.setState({ openSponsor: false, sponsorImage: null });
    this.closeSponsor();
  };

  // Update Sponsor
  updateSponsor = (values, logo) => {
    if (!logo) {
      this.setState({ reqErrorMsg: "Upload sponsor image" });
      return false;
    }

    const data = this.state.sponsorForUpdate;
    data.logo = logo;
    data.name = values.name;
    data.type = values.type;
    this.sponsorArray[this.state.sponsorIndex] = data;

    if (values.id) {
      this.props.updateLoader(true);
      this.microWebSiteService
        .updateSponsor(data)
        .then(res => {
          this.props.updateLoader(false);
          this.closeSponsor();
          toast.success("Sponsor updated successfully");
        })
        .catch(err => {
          this.closeSponsor();
          this.props.updateLoader(false);
          errorHandler(err, this.props.logout);
        });
    } else {
      this.closeSponsor();
    }
  };

  // To Delete Sponsor Details
  deleteSponsor = () => {
    this.props.updateLoader(true);
    this.microWebSiteService
      .deleteSponsor(this.state.deleteSponsorId)
      .then(res => {
        this.sponsorArray.splice(this.state.sponsorIndex, 1);
        this.setState({
          sponsorIndex: null,
          deleteSponsorId: null,
          openConfirm: false,
        });
        this.props.updateLoader(false);
        toast.success("Sponsor deleted succesfully");
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  // To Edit Sponsor Details
  openEditSponsor = (el, i) => {
    const data = el;
    data.index = i;
    this.setState({
      sponsorForUpdate: data,
      sponsorIndex: i,
      sponsorImage: el.logo,
    });
  };

  // Open confirmation modal
  confirmed = key => {
    if (key === "deleteSponsor") {
      this.deleteSponsor();
    } else if (key === "deleteTempSponsor") {
      this.sponsorArray.splice(this.state.sponsorIndex, 1);
      this.setState({ openConfirm: false });
    }
  };

  // Create website
  onSubmit = (values, isSubmit) => {
    if (this.state.isTime) {
      const data = {
        organizationId: this.props.match.params.id.replace("config-", ""),
        title: values.customHeading,
        layout: this.state.selectedLayout,
        color: this.state?.color,
        logo: this.state?.microWebSiteLogo ? this.state.microWebSiteLogo : null,
        banner: this.state?.microWebSiteBannerImage ? this.state.microWebSiteBannerImage : null,
        customImage: [],
        aboutUs: {
          bio: values.aboutUs,
          img: this.state.aboutUsImage ? this.state.aboutUsImage : null,
        },
        contactDetails: {
          whatsapp: { code: values.countryCode, number: values.Whatsapp },
        },
        sponsors: this.sponsorArray,
        isDeleted: false,
      };
      this.state.customImages.map(el => {
        if (el?.url) {
          data?.customImage.push(el);
        }
      });
      this.state.extraDetails.map(el => {
        if (el.value) {
          data.contactDetails[el.label] = el.value;
        }
      });

      if (isSubmit) {
        this.props.updateLoader(true);
        this.microWebSiteService
          .createMicroWebsite(data)
          .then(res => {
            toast.success("Micro website created succesfully");
            this.props.updateLoader(false);
            this.props.history.push("/organizations");
          })
          .catch(err => {
            this.props.updateLoader(false);
            errorHandler(err, this.props.logout);
          });
      } else {
        data.aboutUs.bio = this.formTempData.bio;
        data.title = this.formTempData.title;
        data.contactDetails.whatsapp = this.formTempData.whatsapp;
        this.setState({
          openPreview: true,
          previewData: data,
        });
      }
    }
  };

  // Update Website
  onUpdate = values => {
    global.countryCode = values.countryCode;
    const data = {
      organizationId: this.props.match.params.id.replace("config-", ""),
      title: values.customHeading,
      layout: this.state.selectedLayout,
      color: this.state.color,
      logo: this.state?.microWebSiteLogo ? this.state.microWebSiteLogo : null,
      banner: this.state?.microWebSiteBannerImage ? this.state?.microWebSiteBannerImage : null,
      customImage: [],
      aboutUs: {
        bio: values.aboutUs,
        img: this.state.aboutUsImage ? this.state.aboutUsImage : null,
      },
      contactDetails: {
        whatsapp: { code: values.countryCode, number: values.Whatsapp },
      },
      sponsors: this.sponsorArray,
      isDeleted: this.state.microWebSiteData?.isDeleted,
    };
    this.state.customImages.map(el => {
      if (el?.url) {
        data?.customImage.push(el);
      }
    });
    this.state.extraDetails.map(el => {
      if (el.value) {
        data.contactDetails[el.label] = el.value;
      }
    });
    this.props.updateLoader(true);
    this.microWebSiteService
      .updateMicroWebsite(this.state.microWebSiteData._id, data)
      .then(res => {
        toast.success("Micro website updated successfully");
        this.props.updateLoader(false);
        this.props.history.push(`/organization/view/${data.organizationId}`);
      })
      .catch(err => {
        this.props.updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  // Add more details toggle
  toggleAddMoreDetails = e => {
    e.preventDefault();
    this.setState({ openAddMoreDetails: !this.state.openAddMoreDetails });
  };

  // Render added details
  renderAddedDetails = details => {
    this.setState({ extraDetails: details, openAddMoreDetails: false });
  };

  // Remove extra details
  removeDetails = (event, value) => {
    event.preventDefault();
    const updateArr = this.state.extraDetails;
    let index = this.state.extraDetails
      .map(el => {
        return el.label;
      })
      .indexOf(value);
    updateArr[index].value = "";
    updateArr[index].isChecked = false;
    this.setState({ extraDetails: updateArr });
  };

  // Show preview before create or update
  openPreview = (value, data) => {
    this.props.showOrHideNav(true);
    this.setState({
      openPreview: value,
      microWebSiteData: data,
    });
  };

  // Get micro-web sites preview
  getPreviewLayout = (previewData, openPreview) => {
    switch (previewData.layout) {
      case "one":
        return (
          <LayoutOne
            isPreview={true}
            openPreview={openPreview}
            microWebSiteData={previewData}
            updateLoader={this.props.updateLoader}
            showOrHideNav={this.props.showOrHideNav}
          />
        );
      case "two":
        return (
          <LayoutTwo
            isPreview={true}
            openPreview={openPreview}
            microWebSiteData={previewData}
            updateLoader={this.props.updateLoader}
            showOrHideNav={this.props.showOrHideNav}
          />
        );
      default:
        return (
          <LayoutThree
            isPreview={true}
            openPreview={openPreview}
            microWebSiteData={previewData}
            updateLoader={this.props.updateLoader}
            showOrHideNav={this.props.showOrHideNav}
          />
        );
    }
  };

  // On color picker color change
  colorOnChange = (key, color) => {
    var colors = this.state.color;
    colors[key] = color.hex;
    this.setState({
      color: colors,
    });
  };

  // Update about us details
  updateAboutUs = e => {
    this.setState({ aboutUsText: e.target.value });
  };

  // Set fetched country codes in state
  setCountryCodes = codes => {
    if (codes) {
      this.setState({
        countryCodes: codes,
      });
    }
  };

  render() {
    const { selectedLayout, invalidImage, openPreview, previewData, invalidLogoImage } = this.state;
    if (this.state.countryCodes) {
      var code;
      var mobile;
      // To set default country code and contact number
      if (this.state.create) {
        code = this.state.organizationData?.socialMediaDetails?.whatsapp?.code;
        mobile = this.state.organizationData?.socialMediaDetails?.whatsapp?.number;
      } else {
        code = this.state.microWebSiteData?.contactDetails?.whatsapp?.code;
        mobile = this.state.microWebSiteData?.contactDetails?.whatsapp?.number;
      }

      return (
        <div>
          {openPreview ? (
            this.getPreviewLayout(previewData, this.openPreview)
          ) : (
            <section className="">
              {/* Common head section (back arrow & grid icon) */}
              {!this.state.create && (
                <IoArrowBackCircleOutline
                  className="back-btn"
                  onClick={() => {
                    this.props.history.push(`/organization/view/${this.organizationId}`);
                  }}
                />
              )}
              {/* Config section */}
              <div className="container p-3">
                <h1 className="fw-bold fs-18 text-white text-center mt-8">
                  <img
                    src={microSettingIc}
                    className="btn-size-20 me-2"
                    alt="micro setting icon"
                  ></img>
                  {HEADING.CONFIG_MICRO_WEBSITE}
                </h1>
                {/* Form Section */}
                <Formik
                  innerRef={this.formikRef}
                  enableReinitialize
                  initialValues={{
                    customHeading: this.state.microWebSiteData?.title
                      ? this.state.microWebSiteData?.title
                      : "",
                    aboutUs: this.state.microWebSiteData?.aboutUs?.bio
                      ? this.state.microWebSiteData?.aboutUs?.bio
                      : "",
                    Whatsapp: this.state.microWebSiteData?.contactDetails?.whatsapp
                      ? mobile
                      : mobile,
                    discord: this.state.microWebSiteData?.contactDetails?.discord
                      ? this.state.microWebSiteData?.contactDetails.discord
                      : this.state.organizationData?.socialMediaDetails?.discord,
                    countryCode: this.state.organizationData?.socialMediaDetails?.whatsapp
                      ? code
                      : global?.countryode
                        ? global?.countryode
                        : "+91",
                  }}
                  validationSchema={Yup.object({
                    customHeading: Yup.string()
                      .trim()
                      .required("Custom heading is Required")
                      .max(12, "Max 12 characters"),
                    aboutUs: Yup.string().trim().max(500, "Max 500 characters"),
                    Whatsapp: Yup.string()
                      .matches(/^[0-9]*$/, "only numerics allowed")
                      .required("Mobile number is required")
                      .min(9, "min 9 digits required")
                      .max(12, "max 12 digits allowed"),
                    discord: Yup.string()
                      .matches(
                        /^(?!.*\.\.)(?!.*\.$)[a-z0-9_.]{2,32}$/,
                        "Invalid Username: Usernames must be 2-32 characters, lowercase, and can only contain letters, numbers, underscores, and periods. Consecutive periods are not allowed."
                      )
                      .test(
                        "no-prohibited-words",
                        "Invalid Username: Usernames cannot impersonate, promote hate, or contain explicit language.",
                        value => {
                          const prohibitedWords = ["discord", "staff", "admin", "system"];
                          return !prohibitedWords.some(word => value?.includes(word));
                        }
                      ),
                    // .required('Username is required'),
                  })}
                  onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      if (this.state?.microWebSiteData?._id) {
                        this.onUpdate(values);
                      } else {
                        this.onSubmit(values, true);
                      }
                    }, 400);
                  }}
                  onReset={(values, { setSubmitting }) => {
                    setTimeout(() => {
                      if (this.state.create) {
                        this.onSubmit(values, false);
                      }
                    }, 400);
                  }}
                >
                  <Form className="" autoComplete="off">
                    <div className="row ps-4 pe-4">
                      <div className="col-lg-6 px-lg-5 col-12">
                        <h1 className="fw-600 fs-16 text-white text-start my-3 cursor-pointer">
                          Select Your Theme
                        </h1>

                        <div className="row justify-content-md-evenly">
                          <div className="col-4 col-md-3 cursor-pointer">
                            <img
                              src={layoutOne}
                              className={
                                selectedLayout === "one" ? "layout-img layout-border" : "layout-img"
                              }
                              id="one"
                              onClick={this.changeActivePreview}
                              alt="layout one"
                            />
                            {selectedLayout === "one" && (
                              <IoIosCheckmarkCircle className="fs-24 mb-2 select-layout" />
                            )}
                            <NavLink to="/organization/micro-website/layoutOne" target="_blank">
                              <FiEye className="btn-size-20 text-white layout-preview" />
                            </NavLink>
                            <h1 className="fs-14 fw-600 text-white text-center cursor-pointer">
                              Layout 1
                            </h1>
                            <p className="fw-600 fs-10 text-center text-white-50">(Default)</p>
                          </div>

                          <div className="col-4 col-md-3 cursor-pointer">
                            <img
                              src={layoutTwo}
                              className={
                                selectedLayout === "two" ? "layout-img layout-border" : "layout-img"
                              }
                              id="two"
                              onClick={this.changeActivePreview}
                              alt="layout two"
                            />
                            {selectedLayout === "two" && (
                              <IoIosCheckmarkCircle className="fs-24 mb-2 select-layout" />
                            )}
                            <NavLink to="/organization/micro-website/layoutTwo" target="_blank">
                              <FiEye className="btn-size-20 text-white layout-preview" />
                            </NavLink>
                            <h1 className="fs-14 fw-600 text-white text-center cursor-pointer">
                              Layout 2
                            </h1>
                          </div>

                          <div className="col-4 col-md-3 cursor-pointer">
                            <img
                              src={layoutThree}
                              className={
                                selectedLayout === "three"
                                  ? "layout-img layout-border"
                                  : "layout-img"
                              }
                              id="three"
                              onClick={this.changeActivePreview}
                              alt="layout three"
                            />
                            {selectedLayout === "three" && (
                              <IoIosCheckmarkCircle className="fs-24 mb-2 select-layout" />
                            )}
                            <NavLink to="/organization/micro-website/layoutThree" target="_blank">
                              <FiEye className="btn-size-20 text-white layout-preview" />
                            </NavLink>
                            <h1 className="fs-14 fw-600 text-white text-center cursor-pointer">
                              Layout 3
                            </h1>
                          </div>
                        </div>

                        <div className="row my-4">
                          <p className="fw-600 fs-16 text-white text-start mb-1 cursor-pointer">
                            Select Color
                          </p>
                          <div className="col-4">
                            <h1 className="fs-14 fw-600 mb-2 text-lg-center text-md-center text-start text-white cursor-pointer">
                              Background
                            </h1>
                            <div className="col-12 d-flex justify-content-center">
                              <ColorPicker
                                className="btn-size-52 "
                                uniqueKey={"background"}
                                value={this.state.color.background}
                                colorOnChange={this.colorOnChange}
                              />
                            </div>
                          </div>

                          <div className="col-4">
                            <h1 className="fs-14 fw-600 mb-2 text-lg-center text-md-center text-center text-white cursor-pointer">
                              Primary
                            </h1>
                            <div className="col-12 d-flex justify-content-center">
                              <ColorPicker
                                uniqueKey={"primary"}
                                value={this.state.color.primary}
                                colorOnChange={this.colorOnChange}
                              />
                            </div>
                          </div>

                          <div className="col-4">
                            <h1 className="fs-14 fw-600 mb-2 text-lg-center text-md-center text-end text-white cursor-pointer">
                              Secondary
                            </h1>
                            <div className="col-12 d-flex justify-content-center">
                              <ColorPicker
                                uniqueKey={"secondary"}
                                value={this.state.color.secondary}
                                colorOnChange={this.colorOnChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row justify-content-lg-center justify-content-md-center">
                          {/* Logo and Banner Container */}
                          <div className="col-12">
                            <div
                              className="row justify-content-center mt-2 mt-lg-3 align-items-center"
                              style={{ gap: "16px" }}
                            >
                              {/* Logo */}
                              <div className="col-auto p-0 me-2">
                                <div className="uploadWithPreview">
                                  <div className="upload-section cursor-pointer">
                                    <input
                                      type="file"
                                      accept=".png, .jpg, .jpeg"
                                      id="upload_cover_file"
                                      hidden
                                      ref={fileInput2 => (this.fileInput2 = fileInput2)}
                                      onChange={e => this.onImageChange(e, "microWebSiteLogo")}
                                      name=""
                                      className="image-input"
                                    />
                                    {this.state?.microWebSiteLogo ? (
                                      <div
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          background: "#111",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={this.state.microWebSiteLogo.url}
                                          alt=""
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                        <AiFillCloseCircle
                                          className="btn-size-20 text-white"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            cursor: "pointer",
                                            zIndex: 2,
                                            background: "#222",
                                            borderRadius: "50%",
                                          }}
                                          onClick={e => this.onClearImage(e, "microWebSiteLogo")}
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className="before-uploaded-panel"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <div
                                          className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                          onClick={this.triggerInputFile2}
                                          style={{
                                            height: "100%",
                                          }}
                                        >
                                          <div className="btn-size-30 d-flex flex-column justify-content-center">
                                            <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                            <h1
                                              className="fs-16 fw-600 text-white-50"
                                              htmlFor="exampleInputText"
                                            >
                                              Logo
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {invalidLogoImage && (
                                      <p className="error-msg mwc-image-validation">
                                        {invalidLogoImage}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                              {/* Banner */}
                              <div className="col-auto p-0 ms-2">
                                <div className="uploadWithPreview">
                                  <div className="upload-section cursor-pointer">
                                    <input
                                      type="file"
                                      id="upload_file"
                                      accept=".png, .jpg, .jpeg"
                                      hidden
                                      ref={fileInput => (this.fileInput = fileInput)}
                                      onChange={e =>
                                        this.onImageChange(e, "microWebSiteBannerImage")
                                      }
                                      name=""
                                      className="image-input"
                                    />
                                    {this.state.microWebSiteBannerImage ? (
                                      <div
                                        style={{
                                          width: "300px",
                                          height: "80px",
                                          background: "#111",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          position: "relative",
                                        }}
                                      >
                                        <img
                                          src={this.state.microWebSiteBannerImage.url}
                                          alt=""
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                        />
                                        <AiFillCloseCircle
                                          className="btn-size-20 text-white"
                                          style={{
                                            position: "absolute",
                                            top: 0,
                                            right: 0,
                                            cursor: "pointer",
                                            zIndex: 2,
                                            background: "#222",
                                            borderRadius: "50%",
                                          }}
                                          onClick={e =>
                                            this.onClearImage(e, "microWebSiteBannerImage")
                                          }
                                        />
                                      </div>
                                    ) : (
                                      <div
                                        className="before-uploaded-panel"
                                        style={{
                                          width: "300px",
                                          height: "80px",
                                          borderRadius: "10px",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <div
                                          className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                          onClick={this.triggerInputFile}
                                          style={{
                                            height: "100%",
                                          }}
                                        >
                                          <div className="btn-size-30 d-flex flex-column justify-content-center">
                                            <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                            <h1
                                              className="fs-16 fw-600 text-white-50"
                                              htmlFor="exampleInputText"
                                            >
                                              Banner
                                            </h1>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    {invalidImage && (
                                      <p className="error-msg mwc-image-validation">
                                        {" "}
                                        {invalidImage}{" "}
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 mt-2">
                            <h1 className="fs-14 fw-600 text-white mt-2 cursor-pointer">
                              {" "}
                              Custom Heading*
                            </h1>
                            <Field
                              name="customHeading"
                              type="text"
                              className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45"
                              placeholder="Enter custom heading"
                              onKeyUp={e => {
                                this.formValueChange(e, "title");
                              }}
                            />
                            <ErrorMessage
                              component="span"
                              className="error-msg"
                              name="customHeading"
                            />
                          </div>

                          <div className="col-12 mt-4 cursor-pointer">
                            <div className="row">
                              <div className="col-12">
                                <h1 className="fs-14 fw-600 text-white mt-2 cursor-pointer">
                                  {" "}
                                  Upload Custom Images{" "}
                                </h1>
                              </div>
                              <input
                                type="file"
                                accept=".png, .jpg, .jpeg"
                                id="upload_cover_file"
                                hidden
                                onChange={this.onCustomImageChange}
                                ref={fileInput3 => (this.fileInput3 = fileInput3)}
                                name=""
                                className="image-input"
                              />

                              {this.state.customImages.map((img, ind) => (
                                <div className="col-lg-4 col-md-4 col-6 mb-4" key={ind}>
                                  <div className="uploadWithPreview">
                                    <div className="upload-section">
                                      {img ? (
                                        <div className="text-right flex-column text-end">
                                          <AiFillCloseCircle
                                            className="btn-size-20 position-absolute text-white"
                                            style={{
                                              marginLeft: "-10px",
                                              marginTop: "-10px",
                                              zIndex: 1,
                                            }}
                                            onClick={e => {
                                              e.stopPropagation();
                                              this.resetCustomImage(e, ind);
                                            }}
                                          />
                                          <div
                                            className="after-uploaded-image"
                                            onClick={e => this.triggerInputFile3(e, ind)}
                                          >
                                            <img src={img.url} alt="" className="" />
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          className="before-uploaded-panel"
                                          onClick={e => this.triggerInputFile3(e, ind)}
                                        >
                                          <div className="upload-banner w-100 d-flex align-items-center justify-content-center">
                                            <div className="btn-size-30 d-flex flex-column justify-content-center">
                                              <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 px-lg-5 col-12">
                        <div className="col-12 mt-4">
                          <div className="row">
                            <div className="col-12">
                              <h1 className="fs-14 fw-600 text-white mt-2">About Us</h1>
                            </div>
                            <div className="col-lg-4 offset-lg-4 col-md-4 offset-md-4 col-6 offset-3">
                              <div className="uploadWithPreview">
                                <div className="upload-section cursor-pointer">
                                  <input
                                    type="file"
                                    id="upload_file"
                                    accept=".png, .jpg, .jpeg"
                                    hidden
                                    ref={fileInput4 => (this.fileInput4 = fileInput4)}
                                    onChange={e => this.onImageChange(e, "aboutUsImage")}
                                    name=""
                                    className="image-input"
                                  />
                                  {this.state.aboutUsImage ? (
                                    <div className="text-right flex-column text-end">
                                      <AiFillCloseCircle
                                        className="btn-size-20 position-absolute text-white"
                                        style={{ marginLeft: "-10px", marginTop: "-10px" }}
                                        onClick={e => this.onClearImage(e, "aboutUsImage")}
                                      />
                                      <div
                                        className="after-uploaded-image"
                                        onClick={this.triggerInputFile4}
                                      >
                                        <img src={this.state.aboutUsImage.url} alt="" />
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="before-uploaded-panel">
                                      <div
                                        className="upload-banner w-100 d-flex align-items-center justify-content-center"
                                        onClick={this.triggerInputFile4}
                                      >
                                        <div className="btn-size-30 d-flex flex-column justify-content-center">
                                          <AiOutlineCloudUpload className="btn-size-25 text-white-50 mx-auto" />
                                          <h1
                                            className="fs-12 fw-600 text-white-50 mt-2"
                                            htmlFor="exampleInputText"
                                          >
                                            About us Banner
                                          </h1>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-12 mt-3">
                          <p className="fs-12 fw-600 text-white-50 mb-0 float-end">{`${this.state.microWebSiteData?.aboutUs?.bio?.length ? this.state.microWebSiteData?.aboutUs?.bio?.length : this.state.aboutUsText?.length}/500`}</p>
                          <Field
                            name="aboutUs"
                            type="text"
                            as="textarea"
                            rows="6"
                            maxLength={500}
                            className="purple-field d-flex align-items-center w-100 border-0 ps-3 pt-2 text-white no-resize"
                            placeholder="Enter About Us description"
                            onKeyUp={e => {
                              this.formValueChange(e, "bio");
                              this.updateAboutUs(e);
                            }}
                          />
                          <ErrorMessage component="span" className="error-msg" name="aboutUs" />
                        </div>

                        <div className="col-12 mt-2">
                          <h1 className="fs-14 fw-600 text-white mt-2 cursor-pointer">
                            Contact Number (WhatsApp)*
                          </h1>

                          <Field
                            name="countryCode"
                            as="select"
                            className="sponsor-dropdown purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45 mb-1"
                          >
                            {this.state?.countryCodes?.map((el, i) => {
                              return (
                                <option value={el.code} key={i}>{`${el.code} ${el.name}`}</option>
                              );
                            })}
                          </Field>
                          <Field
                            name="Whatsapp"
                            type="text"
                            className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white height-45 mt-2"
                            placeholder="Enter WhatsApp Number"
                            onKeyUp={e => {
                              this.formValueChange(e, "whatsapp");
                            }}
                          />
                          <ErrorMessage component="span" className="error-msg" name="Whatsapp" />
                        </div>

                        {/* <div className="col-12 mt-2">
                          <label htmlFor="userName" className="fs-16 fw-600 text-white mb-1 mt-2 mt-lg-3">Discord Username</label>
                          <Field
                            name="discord"
                            type="text"
                            className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                            placeholder="mike#1234"
                          />
                          <ErrorMessage component="span" className="error-msg" name="discord" />
                        </div> */}

                        {this.state.extraDetails?.map((el, i) => {
                          return el.value !== "" && el.error === "" ? (
                            <div className="my-2" key={i}>
                              <h1 className="fs-14 fw-bold mt-2 text-white">
                                {capitalize(el.label)}
                              </h1>
                              <div
                                className="purple-field d-flex align-items-center w-100 border-0 position-relative"
                                style={{ paddingRight: 0 }}
                              >
                                {el.key === "instagram" && (
                                  <AiFillInstagram
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "facebook" && (
                                  <RiFacebookFill
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "x" && (
                                  <FaXTwitter
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "twitch" && (
                                  <FaTwitch
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "telegram" && (
                                  <FaTelegramPlane
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "youtube" && (
                                  <AiFillYoutube
                                    className="position-absolute"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      color: "#fff",
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                {el.key === "loco" && (
                                  <img
                                    src={loco}
                                    className="position-absolute"
                                    alt="loco"
                                    style={{
                                      left: 12,
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      width: 20,
                                      height: 20,
                                      filter: "drop-shadow(0 0 4px #888)",
                                    }}
                                  />
                                )}
                                <input
                                  type="text"
                                  className="purple-field d-flex align-items-center w-100 border-0 text-white height-45 pe-5"
                                  style={{
                                    paddingLeft: 40,
                                    paddingRight: 40,
                                    background: "transparent",
                                  }}
                                  disabled
                                  value={el.value}
                                />
                                <AiOutlineMinusCircle
                                  className="btn-size-20 text-white position-absolute cursor-pointer"
                                  style={{
                                    right: 16,
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    filter: "drop-shadow(0 0 4px #888)",
                                    background: "none",
                                    border: "none",
                                    boxShadow: "none",
                                    pointerEvents: "auto",
                                  }}
                                  onClick={e => this.removeDetails(e, el.label)}
                                />
                              </div>
                            </div>
                          ) : null;
                        })}
                        <div className="col-12 col-md-6 offset-md-3 mt-3">
                          <div
                            className="black-flat-btn text-center py-2 rounded-10 cursor-pointer"
                            onClick={e => this.toggleAddMoreDetails(e)}
                          >
                            <button className="bg-transparent border-0">
                              <AiFillPlusCircle className="btn-size-20 text-white" />
                              <h1 className="ms-2 fs-16 fw-600 text-white text-center d-inline">
                                Add Social Media
                              </h1>
                            </button>
                          </div>
                        </div>

                        <div className="col-12 mt-3 ">
                          <div className="row">
                            {this.sponsorArray.map((el, i) => {
                              return (
                                <div className="col-lg-6 col-md-6" key={i}>
                                  <div className="addMoreField sponsor-border pt-4 mt-3 pb-4 h-auto">
                                    <div className="col-10 offset-1 d-flex justify-content-center">
                                      <h1 className="fs-14 fw-bold text-white mt-2">
                                        {" "}
                                        Sponsor {i + 1}{" "}
                                      </h1>
                                      <FiEdit
                                        className="text-white mt-2 ms-3 cursor-pointer"
                                        onClick={() => {
                                          this.openEditSponsor(el, i);
                                        }}
                                      />
                                      <HiOutlineTrash
                                        className="text-white mt-2 ms-2 cursor-pointer"
                                        onClick={() => {
                                          this.onClickOpenConfirm(
                                            el?.createdAt ? "deleteSponsor" : "deleteTempSponsor",
                                            this.sponsorDeleteMsg(el?.name)
                                          );
                                          this.setState({
                                            deleteSponsorId: el._id,
                                            sponsorIndex: i,
                                          });
                                        }}
                                      />
                                    </div>
                                    <div className="col-10 offset-1">
                                      <label
                                        className="fs-14 fw-bold text-white mt-2 float-start"
                                        htmlFor=""
                                      >
                                        {" "}
                                        Sponsor Name{" "}
                                      </label>
                                      <input
                                        type="text"
                                        value={el?.name}
                                        className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                                        disabled
                                      />
                                    </div>
                                    <div className="col-10 offset-1">
                                      <label
                                        className="fs-14 fw-bold text-white mt-2 float-start"
                                        htmlFor=""
                                      >
                                        {" "}
                                        Sponsor Title{" "}
                                      </label>
                                      <input
                                        type="text"
                                        value={el?.type}
                                        className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45"
                                        disabled
                                      />
                                    </div>
                                    <div className="align-self-center mt-3">
                                      <img
                                        src={el?.logo?.url}
                                        alt=""
                                        width="200"
                                        height="100"
                                        className="border border-2 rounded-10"
                                      />
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>

                        <div className="col-12 col-md-6 offset-md-3 mt-3">
                          <div className="black-flat-btn text-center py-2 rounded-10">
                            <button
                              className="bg-transparent border-0"
                              type="button"
                              onClick={() => {
                                this.toggleModal("openSponsor");
                                this.setState({
                                  sponsorForUpdate: {},
                                  sponsorIndex: null,
                                });
                              }}
                            >
                              <AiFillPlusCircle className="btn-size-20 text-white" />
                              <h1 className="ms-2 fs-16 fw-600 text-white text-center d-inline">
                                {" "}
                                Add Sponsor{" "}
                              </h1>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="d-flex justify-content-center mt-4 mb-8">
                      <div className="d-flex flex-column align-items-center mx-4">
                        {this.state.create && (
                          <>
                            <button
                              className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-45"
                              type="reset"
                            >
                              <img src={eyeIc} className="black-rock btn-size-20" />
                            </button>
                            <p className="fs-16 fw-700 text-white text-center mt-2">Preview</p>
                          </>
                        )}
                      </div>
                      <div className="d-flex flex-column align-items-center mx-2">
                        <button
                          className="round-btn rounded-circle d-flex align-items-center justify-content-center border-0 btn-size-45"
                          type="submit"
                        >
                          <BsArrowRight className="black-rock fs-24" />
                        </button>
                        <p className="fs-16 fw-700 text-white text-center mt-2">Save</p>
                      </div>
                    </div>
                  </Form>
                </Formik>
              </div>

              {/* Add sponsor details modal */}
              <Modal
                show={this.state.openSponsor || this.state.sponsorForUpdate}
                centered
                dialogClassName="BioEdit-modal"
              >
                <Modal.Body>
                  <Sponsor
                    updateLoader={this.props.updateLoader}
                    updateSponsor={this.updateSponsor}
                    sponsorIndex={this.state.sponsorIndex}
                    addSponsor={this.addSponsor}
                    sponsorArray={this.sponsorArray?.length}
                    sponsorForUpdate={this.state.sponsorForUpdate}
                    onClose={() => {
                      this.setState({ openSponsor: false, sponsorForUpdate: null });
                    }}
                  />
                </Modal.Body>
              </Modal>
              {/* Add more contact details modal */}
              <Modal
                show={this.state.openAddMoreDetails}
                centered
                dialogClassName="AddMoreDetails-modal"
              >
                <Modal.Body>
                  <OrgAddMoreDetails
                    toggleAddMoreDetails={this.toggleAddMoreDetails}
                    renderAddedDetails={this.renderAddedDetails}
                    data={this.state.extraDetails}
                  />
                </Modal.Body>
              </Modal>
              {/* Users confirmation modal */}
              <Modal show={this.state.openConfirm} centered dialogClassName="Confirmation-modal">
                <Modal.Body>
                  <ConfirmationModal
                    confirm={this.state.confirm}
                    onClickOpenConfirm={this.onClickOpenConfirm}
                    confirmed={this.confirmed}
                  />
                </Modal.Body>
              </Modal>

              {/* Logo Image Cropper */}
              <ImageCropper
                show={this.state.showLogoCropper}
                onHide={this.hideLogoCropper}
                imageUrl={this.state.logoCropperImageUrl}
                aspectRatio={this.state.logoCropperAspectRatio}
                onCropComplete={this.handleLogoCropComplete}
                width={400}
                height={400}
              />

              {/* Banner Image Cropper */}
              <ImageCropper
                show={this.state.showBannerCropper}
                onHide={this.hideBannerCropper}
                imageUrl={this.state.bannerCropperImageUrl}
                aspectRatio={this.state.bannerCropperAspectRatio}
                onCropComplete={this.handleBannerCropComplete}
                width={2378}
                height={400}
              />
            </section>
          )}
        </div>
      );
    } else {
      return <div>No record found</div>;
    }
  }
}
